export enum MatchCodesActionType {
    START_REQUEST = 'START_MATCH_CODES_REQUEST',
    LOAD_SUCCESS = 'LOAD_MATCH_CODES_SUCCESS',
    LOAD_ERROR = 'LOAD_MATCH_CODES_ERROR',
    RESET_CACHE = 'RESET_MATCH_CODES_CACHE',
    UNKNOWN = 'UNKNOWN'
}
